import {Injectable} from '@angular/core';
import {BarcodeScanner, BarcodeScannerOptions} from '@ionic-native/barcode-scanner/ngx';
import {LokijsService} from './database/lokijs.service';
import {StateManagerService} from './state-manager.service';
import {DetaillineDTOModel} from '../models/detaillineDTO.model';
import {CollectionsNames} from '../definitions/collections-names';

@Injectable({
    providedIn: 'root'
})
export class ScanBarcodeService {

    private barcodeScannerOptions: BarcodeScannerOptions = {
        showTorchButton: true,
        showFlipCameraButton: true,
        orientation: 'landscape'
    };
    private barcode: string;

    constructor(private barcodeScanner: BarcodeScanner,
                private lokiJs: LokijsService,
                private stateManager: StateManagerService,
                private collectionNames: CollectionsNames) {
    }

    async scanCode() {
        return this.barcodeScanner
            .scan(this.barcodeScannerOptions);
    }

    findPlantItemByBarcode(barcode: string) {
        let tempEquip = null;
        const fullEquipList = this.lokiJs.getCollection('equipment')
            .chain().find({stat: 1}).data();
        fullEquipList.forEach(equip => {
            if (equip.barcode) {
                // Remove '-' from DB
                const tempString = equip.barcode.split('-');
                const tempBarcode = tempString.join('');

                // Remove '-' from reading
                const tempStringRead = barcode.split('-');
                const tempBarcodeRead = tempStringRead.join('');
                if (equip.barcode) {
                    if (equip.barcode.length > 0
                        && (tempBarcode.length / tempBarcodeRead.length >= 0.8)
                        && tempBarcodeRead.includes(tempBarcode)) {
                        tempEquip = equip;
                    }
                }
            }
        });
        return JSON.parse(JSON.stringify(tempEquip));
    }

    findPlantItemByExactBarcode(barcode: string) {
        let tempEquip = null;
        const fullEquipList = this.stateManager.getCollection('equipment') as DetaillineDTOModel[];
        console.log(fullEquipList);
        tempEquip = fullEquipList.find(equip => {
            if (equip.barcode) {
                return equip.barcode === barcode;
            }
        });
        console.log(tempEquip);
        if (tempEquip) {
            console.log(tempEquip);
            return JSON.parse(JSON.stringify(tempEquip));
        }
    }

    findLiveLineByBarcode(barcode: string) {
        let tempEquip = null;
        const equipmentList = this.stateManager.getCollection(this.collectionNames.EQUIPMENT) as DetaillineDTOModel[];
        const fullLiveDetailLines = this.stateManager.getCollection(this.collectionNames.LIVEDETAILLINES) as DetaillineDTOModel[];
        console.log(fullLiveDetailLines);
        tempEquip = equipmentList.find(equip => {
            if (equip.barcode) {
                return equip.barcode === barcode;
            }
        });
        console.log(tempEquip);
        const liveLine = fullLiveDetailLines.find(equip => {
            return equip.pdesc === tempEquip.pdesc && equip.reg === tempEquip.reg;
        });
        console.log(liveLine);
        if (liveLine) {
            return JSON.parse(JSON.stringify(liveLine));
        }
    }

    findProductWithBarcode(barcode: string) {
        const productList = this.stateManager.getCollection(this.collectionNames.PRODUCTBARCODESTOCKTAKE) as DetaillineDTOModel[];
        console.log(productList);
        const tempProd = productList.find(prod => {
            if (prod.barcode) {
                return prod.barcode === barcode;
            }
        });
        return tempProd ? JSON.parse(JSON.stringify(tempProd)) : null;
    }
}
